{
  "pt": {
    "ai": {
      "activation": {
        "activate": "Ativar",
        "activated": "O assistente de IA está ativo para {client}.",
        "agreement_required": "Assinale primeiro a caixa de aceitação.",
        "deactivated": "O assistente de IA está desativado para {client}.",
        "not_now": "Agora não",
        "prompt": {
          "agreement": "Em nome de {client}, aceito o Google Cloud como subcontratante para esta funcionalidade.",
          "dpa_label": "Acordo de tratamento de dados atualizado",
          "dpa_url": "https://ziggu.io/terms-and-conditions-13-10-2026",
          "intro": "Resuma conversas e receba sugestões de resposta. Teste gratuito até 31 de dezembro de 2026.",
          "processing": "Para usar o assistente, o texto das conversas é processado através do Google Cloud (Gemini) na UE. A Google não utiliza estes dados para treinar modelos.",
          "retention": "Guardamos as conversas com o assistente durante {count} mês. | Guardamos as conversas com o assistente durante {count} meses.",
          "settings": "Pode ativar ou desativar o assistente a qualquer momento nas definições, em {features} > {conversations}.",
          "title": "Novo: assistente de IA para a sua equipa de projeto"
        },
        "settings": {
          "description": "Resume conversas e sugere respostas. Para o ativar, tem de aceitar o Google Cloud como subcontratante.",
          "impersonation": "Só um proprietário do cliente pode ativar ou desativar isto, não numa sessão «entrar como».",
          "owner_only": "Peça a um proprietário para ativar o assistente de IA.",
          "owner_only_enabled": "Só um proprietário pode desativar o assistente de IA.",
          "title": "Assistente de IA",
          "toggle": "Assistente de IA nas conversas"
        },
        "snoozed": "Pode ativar o assistente de IA mais tarde nas definições, em {features} > {conversations}."
      },
      "assistant": {
        "all_projects": "Todos os projetos",
        "cap": {
          "action": "Iniciar uma nova conversa",
          "message": "Atingiu o limite de conversa."
        },
        "empty_state": {
          "subtitle": "Pergunte-me qualquer coisa sobre os seus clientes",
          "title": "Como posso ajudá-lo?"
        },
        "errors": {
          "budget_reached": "O orçamento de IA deste mês foi esgotado. Contacte a Ziggu para o aumentar.",
          "generic": "Algo correu mal. Tente novamente."
        },
        "history": {
          "empty": "Ainda não há conversas anteriores",
          "title": "Conversas anteriores"
        },
        "input": {
          "disclaimer": "Os resultados podem ser imprecisos. Verifique sempre as informações importantes.",
          "hint": "Enter para enviar · Shift+Enter para nova linha",
          "placeholder": "Pergunte sobre os seus clientes..."
        },
        "name": "Ziggy",
        "suggestions": {
          "help_notifications": "Como configuro as notificações?",
          "help_project_settings": "Onde encontro as definições do projeto?",
          "open_decisions": "Quais decisões ainda estão em aberto?",
          "unassigned_units": "Quais unidades ainda não têm cliente?"
        },
        "support_cta": {
          "action": "Contactar o suporte",
          "prompt": "Não era a resposta que procurava?"
        }
      },
      "dashboard": {
        "agents": {
          "all": "Todos os módulos",
          "assistant": "Assistente",
          "conversation_agent": "Agente de conversação",
          "label": "Módulo"
        },
        "allowance": {
          "edit": "Editar orçamento"
        },
        "allowance_boost": {
          "action": "Aumentar temporariamente",
          "action_short": "Aumentar",
          "amount_label": "Valor adicional",
          "existing": "Já existe um aumento de {amount} ativo neste período. Este valor é somado.",
          "expires": "É somado ao orçamento apenas neste período e expira a {date}.",
          "expires_next_reset": "É somado ao orçamento apenas neste período e expira na próxima reposição.",
          "save": "Adicionar aumento",
          "saved": "Aumento de {amount} adicionado"
        },
        "allowance_history": {
          "empty": "Ainda sem alterações",
          "empty_hint": "Este cliente continua com o orçamento que lhe foi atribuído.",
          "entry": "{field}: {before} → {after}",
          "package_amount": "valor do pacote",
          "title": "Histórico do orçamento",
          "unknown_author": "Desconhecido"
        },
        "chat_detail": {
          "employee": "Colaborador",
          "empty": "Esta conversa não tem mensagens",
          "feedback": {
            "down": "Má resposta",
            "up": "Boa resposta"
          },
          "text_hidden": "Não partilhado pelo colaborador",
          "title": "Conversa"
        },
        "chats": {
          "columns": {
            "cost": "Custo",
            "employee": "Colaborador",
            "intent": "Intenção",
            "ticket": "Ticket",
            "turns": "Turnos",
            "when": "Quando"
          },
          "empty": "Sem conversas neste período",
          "feedback_label": "Avaliação",
          "feedbacks": {
            "all": "Qualquer avaliação",
            "down": "Polegar para baixo",
            "up": "Polegar para cima"
          },
          "intent_label": "Intenção",
          "open": "Abrir conversa",
          "title": "Conversas",
          "via": "via {name}"
        },
        "client": {
          "allowance_boost": "{amount} adicional até {date}",
          "allowance_boost_next_reset": "{amount} adicional até à próxima reposição",
          "allowance_free": "{amount} gratuito",
          "allowance_paid": "{amount} pago",
          "employees_active": "{count} colaborador ativo | {count} colaboradores ativos",
          "over_since": "Ultrapassado desde {date}",
          "title": "{name} · IA",
          "used": "{used} de {allowance} utilizados"
        },
        "clients": {
          "allowance_split": "Gratuito {free} · Pago {paid}",
          "allowance_split_boost": "Gratuito {free} · Pago {paid} · Adicional {boost}",
          "columns": {
            "actions": "Ações",
            "allowance": "Orçamento",
            "chats": "Conversas no período",
            "client": "Cliente",
            "spend": "Gasto no período",
            "status": "Estado",
            "used": "Utilizado este mês"
          },
          "empty": "Nenhum cliente utilizou IA neste período",
          "export": "Exportar",
          "title": "Clientes"
        },
        "empty_hint": "Sem resultados para este módulo e período.",
        "intent_mix": {
          "empty": "Sem conversas neste período",
          "row": "{chats} conversa · {amount} | {chats} conversas · {amount}",
          "title": "Distribuição por intenção"
        },
        "intents": {
          "all": "Todas as intenções",
          "draft": "Redigir uma resposta",
          "none": "Sem intenção",
          "question": "Perguntar",
          "summary": "Resumo"
        },
        "kpi": {
          "clients_active": "Clientes ativos",
          "employees_active": "Colaboradores ativos",
          "spend_month": "Gasto este mês",
          "spend_month_detail": "Mês de calendário em curso",
          "spend_range": "Gasto no período",
          "spend_range_detail": "{count} conversa neste período | {count} conversas neste período",
          "spend_today": "Gasto de hoje",
          "tickets_assisted": "Tickets assistidos"
        },
        "load_failed": {
          "description": "Recarregue a página ou escolha outro período.",
          "title": "Não foi possível carregar a utilização de IA"
        },
        "range": {
          "label": "Período"
        },
        "spend": {
          "empty": "Sem gastos neste período",
          "monthly_empty": "Sem gastos nos últimos {months} meses",
          "monthly_hint": "Últimos {months} meses · não depende do período selecionado",
          "monthly_title": "Custo por mês",
          "monthly_total": "{amount} nos últimos {months} meses · não depende do período selecionado",
          "title": "Gasto por dia",
          "total": "{amount} no período",
          "view": {
            "label": "Mostrar gastos",
            "per_day": "Por dia",
            "running_total": "Acumulado"
          }
        },
        "status": {
          "over": "Orçamento ultrapassado",
          "over_days": "Ultrapassado · 1 dia | Ultrapassado · {count} dias"
        },
        "title": "Utilização de IA"
      },
      "settings": {
        "budget": {
          "amount_error": "Introduza um valor como 2 ou 2.50",
          "boost_label": "Aumento temporário",
          "boost_label_until": "Aumento temporário até {date}",
          "description": "Limite mensal de custo para utilização de IA (fase de teste). Recalculado com base no consumo de tokens em todas as conversas deste mês.",
          "free_label": "Orçamento gratuito",
          "override_help": "Deixe vazio para utilizar o valor do pacote ({amount}).",
          "override_label": "Orçamento gratuito personalizado",
          "paid_label": "Orçamento pago",
          "save": "Guardar",
          "title": "Orçamento mensal",
          "total_label": "Orçamento total",
          "usage_label": "Utilizado este mês",
          "usage_of": "Utilizado este mês, de {amount}",
          "use_package_amount": "Utilizar o valor do pacote"
        },
        "description": "Configuração das funcionalidades de IA na sua organização.",
        "title": "Definições de IA",
        "usage": {
          "description": "Quanto do saldo de IA deste mês já foi utilizado. Aos 100%, as funcionalidades de IA param até o saldo ser renovado no próximo mês.",
          "title": "Utilização de IA"
        }
      },
      "ticket_assistant": {
        "actions": {
          "adjust": "Ajustar",
          "ask": "Perguntar",
          "draft": "Redigir uma resposta",
          "draft_empty": "Ainda não há mensagens para responder",
          "follow_up": "Seguimento",
          "follow_up_stop": "Parar o seguimento",
          "new": "Nova pergunta",
          "summary": "Resumir a conversa",
          "summary_empty": "Ainda não há mensagens para resumir",
          "use_as_reply": "Usar como resposta"
        },
        "adjusting_draft": "Ajuste deste rascunho",
        "beta": "Beta",
        "beta_tooltip": "Gratuito até ao final de 2026. Depois, a utilização será limitada.",
        "budget": {
          "description": "O orçamento de IA deste mês foi esgotado. As respostas anteriores continuam disponíveis.",
          "request": "Esgotámos o orçamento de IA deste mês e gostaríamos de o aumentar.",
          "request_low": "Esgotámos quase todo o orçamento de IA deste mês e gostaríamos de o aumentar.",
          "title": "Orçamento de IA atingido",
          "warn": "{percent}% do orçamento de IA deste mês utilizado."
        },
        "cap": "Esta conversa ficou longa. É melhor fazer uma nova pergunta.",
        "collapse": "Ocultar assistente",
        "conversation": "Conversa",
        "digest": {
          "decisions_open": "nenhuma decisão em aberto | 1 decisão em aberto | {count} decisões em aberto",
          "installments_unpaid": "nenhuma prestação por pagar | 1 prestação por pagar | {count} prestações por pagar",
          "issues_open": "nenhuma ocorrência de pós-venda em aberto | 1 ocorrência de pós-venda em aberto | {count} ocorrências de pós-venda em aberto",
          "nothing_open": "Nada em aberto para esta unidade",
          "overdue": "{count} em atraso",
          "title": "Num relance"
        },
        "earlier_answers": "Respostas anteriores",
        "empty": "Pergunte algo sobre esta conversa ou comece com uma destas.",
        "expand": "Mostrar assistente",
        "feedback": {
          "bad": "Má resposta",
          "consent": "A Ziggu verá esta conversa. Pode conter nomes e dados de clientes.",
          "consent_shared": "Esta conversa já está partilhada com a Ziggu.",
          "good": "Boa resposta",
          "note": "O que deveria ter dito? (opcional)",
          "send": "Enviar",
          "share": "Partilhar com a Ziggu",
          "stop_sharing": "Deixar de partilhar",
          "thanks": "Obrigado pelo seu feedback.",
          "thanks_shared": "Obrigado. Partilhada com a Ziggu.",
          "undo": "Anular"
        },
        "following_up": "Seguimento desta resposta",
        "footer": "O suporte da Ziggu só lê isto se o partilhar ou der acesso à Ziggu. As respostas são geradas por IA e podem conter erros.",
        "footer_shared": "Partilhou esta conversa com a Ziggu. As respostas são geradas por IA e podem conter erros.",
        "input": {
          "adjust_draft": "Ajuste este rascunho, p. ex. mais curto ou mais formal",
          "follow_up": "Faça uma pergunta de seguimento",
          "label": "A sua pergunta",
          "placeholder": "Pergunte sobre esta conversa"
        },
        "links": {
          "aftercare": "Pós-venda",
          "decisions": "Decisões",
          "financials": "Finanças"
        },
        "placeholders": {
          "confirm": {
            "accept": "Enviar mesmo assim",
            "header": "Enviar com dados por preencher?",
            "message": "O assistente deixou 1 dado por preencher nesta resposta. | O assistente deixou {count} dados por preencher nesta resposta."
          },
          "remaining": "1 dado por preencher | {count} dados por preencher"
        },
        "replace_reply": {
          "confirm": {
            "accept": "Substituir",
            "header": "Substituir o texto escrito?",
            "message": "O rascunho substitui o texto da caixa de resposta."
          }
        },
        "resize": "Redimensionar assistente",
        "suggestions": {
          "history": "Qual é o histórico com este cliente?",
          "issues_open": "Quantos defeitos continuam em aberto?",
          "undecided": "O que este cliente ainda não decidiu?"
        },
        "thinking": "O assistente está a trabalhar...",
        "title": "Assistente"
      }
    }
  }
}
